"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { SectionContainer, TwoColumnLayout } from "./layouts";
import { useWebViewAuthModal } from "@/hooks/client/useWebViewAuthModal";

interface CompareMemberRatesSectionProps {
  title: string;
  subtitle: string;
  topLabel?: string;
  ctaText?: string;
}

const CompareMemberRatesSection: React.FC<CompareMemberRatesSectionProps> = ({
  title,
  subtitle,
  topLabel,
  ctaText,
}) => {
  const { handleClick, AuthModals } = useWebViewAuthModal();

  return (
    <>
      <SectionContainer background="transparent">
        <TwoColumnLayout
          className="lg:items-center"
          leftContent={
            <div className="flex w-full max-w-full flex-col items-center justify-center gap-6 lg:items-start lg:justify-start">
              <div className="flex w-full flex-col items-center justify-center gap-4 lg:items-start lg:justify-start">
                {/* Top Label */}
                {topLabel && (
                  <div className="w-full text-center font-figtree text-lg font-medium leading-relaxed text-muted-foreground lg:text-left">
                    {topLabel}
                  </div>
                )}

                {/* Title and Subtitle */}
                <div className="flex w-full flex-col items-center justify-center gap-6 lg:items-start lg:justify-start">
                  {/* Title */}
                  <div className="w-full text-balance text-center font-figtree text-4xl font-semibold leading-9 text-foreground lg:text-left lg:text-6xl lg:leading-none">
                    {title}
                  </div>

                  {/* Subtitle */}
                  <div className="w-full max-w-[417px] text-center font-figtree text-base font-medium leading-relaxed text-muted-foreground lg:text-left lg:text-xl lg:leading-7">
                    {subtitle}
                  </div>
                </div>
              </div>

              {/* CTA Button */}
              {ctaText && (
                <Button
                  onClick={handleClick}
                  variant="orange-gradient"
                  className="font-figtree leading-6 text-pure-white"
                >
                  {ctaText}
                </Button>
              )}
            </div>
          }
          rightContent={
            <div className="relative flex w-full items-center justify-center overflow-hidden rounded-lg">
              <img
                src="/assets/landing-page/compare.jpg"
                alt="Compare member rates"
                className="h-auto w-full max-w-full scale-125 object-cover lg:scale-100 lg:object-contain"
                width={1956}
                height={1872}
                loading="lazy"
              />
            </div>
          }
          gap="xl"
        />
      </SectionContainer>
      <AuthModals />
    </>
  );
};

export default CompareMemberRatesSection;
